<template>
    <div class="member-container">
        <el-row :gutter="10">
            <el-col :span="8" class="content-container">
                <!-- <h4>我的二维码</h4>
                <div>

                </div> -->
                <h4>手动添加</h4>
                <el-form :model="addForm" ref="addForm" :rules="rules" label-width="110px">
                    <el-form-item label="小组名称" prop="groupId">
                        <el-select v-model="addForm.groupId">
                            <el-option v-for="(g,idx) in groupList" :key="idx" :label="g.name" :value="g.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="客服" prop="tjkId">
                        <tjkautocompleteall @change="updateAddTjkId"></tjkautocompleteall>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="addMember">添加</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
            <el-col :span="16" class="content-container">
                <h4>成员列表</h4>
                <el-form ref="searchForm" :model="searchForm" :inline="true">
                    <el-form-item label="客服">
                        <tjkautocompleteall @change="updateTjkId"></tjkautocompleteall>
                    </el-form-item>
                    <el-form-item>
                        <el-form-item label="小组名称">
                            <el-select v-model="searchForm.groupId">
                                <el-option v-for="(g,idx) in groupList" :key="idx" :label="g.name" :value="g.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="getList(1)">查询</el-button>
                    </el-form-item>
                </el-form>
                <el-table :data="list" border highlight-current-row>
                    <el-table-column label="客服" align="center">
                        <template slot-scope="scope">
                            <div>
                            {{ scope.row.tjkName }}({{scope.row.tjkNumber}})
                            <el-tooltip effect="dark" :content="scope.row.memberTagName" placement="top">
                                <img v-if="scope.row.tjkTypeTag" :src="scope.row.tjkTypeTag | tagFilter">
                            </el-tooltip>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="添加时间" align="center">
                        <template slot-scope="scope">
                            {{scope.row.createTime}}
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="加入方式" align="center">
                        <template slot-scope="scope">
                            {{scope.row.createTime}}
                        </template>
                    </el-table-column> -->
                    <el-table-column label="操作" align="center">
                        <template slot-scope="scope">
                            <el-button type="danger" @click="deleteRow(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <pagination :pages="pages" :pageNum="searchForm.pageNum" @getData="getList"></pagination>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    data() {
        return {
            referral: '',
            addForm: {
                tjkId: '',
                groupId: ''
            },
            searchForm: {
                tjkId: '',
                groupId: '',
                pageNum: 1,
                pageSize: 10
            },
            pages: 1,
            list: [],
            groupList: [],
            rules: {
                tjkId: [{required: true, message: '请选择客服', trigger: 'blur'}],
                groupId: [{required: true, message: '请选择小组名称', trigger: 'blur'}],
            }
        }
    },
    created(){
        var login_token = this.$route.query.token;
        document.cookie = 'login_token=' + login_token;
        this.getLeader();
    },
    methods: {
        //列表页淘金客自动搜索
        updateTjkId(val) {
            this.searchForm.tjkId = val
        },
        updateAddTjkId(val) {
            this.addForm.tjkId = val
        },
        getLeader(){
            this.$http.post(API_ROOT.tjkuser + '/group/queryLeaderGroup').then(response => {
                var result = response.data
                if(result.success){
                    this.groupList = result.data;
                    this.addForm.groupId = result.data[0].id;
                    this.searchForm.groupId = result.data[0].id;
                    this.getList(1);
                }else{
                    this.$alert('获取 groupId 失败：' + result.msg)
                }
                
            }, response => {
                this.$alert('网络繁忙，请稍后重试！')
            })
        },
        addMember(){
            this.$refs.addForm.validate(valid => {
                if(valid){
                    this.$http.post(API_ROOT.tjkuser + '/group/member/add', this.addForm).then(response => {
                        var result = response.data
                        if(result.success) {
                            this.$alert('添加成功')
                            this.getList(1)
                        }else{
                            this.$alert(result.msg)
                        }
                    }, response => {
                        this.$alert('网络繁忙，请稍后重试！')
                    })
                }else{
                    return;
                }
            })
            
        },
        getList(num){
            this.searchForm.pageNum = num;
            
            this.$http.post(API_ROOT.tjkuser + '/group/member/query', this.searchForm).then(response => {
                var result = response.data
                if(result.success) {
                    this.pages = result.data.pages
                    this.searchForm.pageNum = result.data.pageNum
                    this.list = result.data.list
                }else {
                    this.$alert(result.msg)
                }
            }, response => {
                this.$alert('网络繁忙，请稍后重试！')
            })
        },
        deleteRow(row){
            let self = this;
            let data = {
                groupId: this.searchForm.groupId,
                memberId: row.memberId
            }
            this.$confirm('确定删除此数据吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http.post(API_ROOT.tjkuser + '/group/member/delete', data).then(response => {
                    var result = response.data
                    if(result.success){
                        this.$alert('删除成功');
                        this.getList(self.searchForm.pageNum);
                    }else{
                        this.$alert(result.msg)
                    }
                }, response => {
                    this.$alert('网络繁忙，请稍后重试！')
                })
            })
            
        }
    },
    filters: {
        tagFilter(val){
            switch(val){
                case 'CloudService':
                    return 'http://taojinyun.file.itaojin.cn/tjkTypeIconYun.png';
                    break;
                case 'ProviderService':
                    return 'http://taojinyun.file.itaojin.cn/tjkTypeIconTuan.png';
                    break;
                case 'SaleService':
                    return 'http://taojinyun.file.itaojin.cn/tjkTypeIconXiao.png';
                    break;
                case 'FreeService':
                    return 'http://taojinyun.file.itaojin.cn/tjkTypeIconZi.png';
                    break;
                case 'MerchantService':
                    return 'http://taojinyun.file.itaojin.cn/tjkTypeIconShang.png';
                    break;
            }
            

        }
    }
}
</script>

<style lang="less">
    .member-container{
        padding: 20px;
        h4{
            margin-bottom: 10px;
            color: #333;
        }
    }
</style>


// WEBPACK FOOTER //
// ./src/page/hawkeye/memberManage.vue